import React from "react";
import styled from "styled-components";
import { useNavigate } from "react-router";

// assets
import ScheduleIcon from "assets/icons/notification/schedule.svg";
import UserIcon from "assets/icons/notification/user.svg";
import SaleIcon from "assets/icons/notification/sale.svg";
import BpayIcon from "assets/icons/notification/saleBpay.svg";
import CoachIcon from "assets/icons/notification/coach.svg";
import NoticeIcon from "assets/icons/notification/notice.svg";
import ClassAutoCloseIcon from "assets/icons/class_close.svg";

// utils
import { getCalendar, getClock, getDateText } from "utils/date";

const NotificationItem = ({ isRead, notification, saveScrollPosition }) => {
  const navigate = useNavigate();

  const NOTIFICATION_ICON_MAP = {
    MANAGER_ALARM_SCHEDULE:
      notification?.alarmTypeDetail === "CLASS_SCHEDULE_CLOSE"
        ? ClassAutoCloseIcon
        : ScheduleIcon,
    MANAGER_ALARM_MEMBER: UserIcon,
    MANAGER_ALARM_SALES:
      notification.alarmTypeDetail === "BPAY_SALES" ? BpayIcon : SaleIcon,
    MANAGER_ALARM_COACH: CoachIcon,
    MANAGER_ALARM_SMS_NOTICE: NoticeIcon,
  };

  const getButtonTitle = () => {
    switch (notification.alarmType) {
      case "MANAGER_ALARM_SCHEDULE":
        return "스케줄 확인하기";
      case "MANAGER_ALARM_SALES":
        return "매출 확인하기";
      case "MANAGER_ALARM_CEO_REPORT":
        return "리포트 확인하기";
      default:
        return "";
    }
  };

  const getButtonAction = () => {
    switch (notification.alarmType) {
      case "MANAGER_ALARM_SCHEDULE":
        return () => {
          navigate(`/schedule`);
          saveScrollPosition();
        };
      case "MANAGER_ALARM_SALES":
        return () => {
          navigate("/sales");
          saveScrollPosition();
        };
      case "MANAGER_ALARM_CEO_REPORT":
        return () => {
          navigate("/report");
          saveScrollPosition();
        };
      case "saleBpay":
        return () => {
          navigate("/sales");
          saveScrollPosition();
        };
      default:
        return () => {};
    }
  };

  const convertNotificationDate = (t) => {
    const dateText = getDateText(t, 2); // today || yesterday

    if (dateText) {
      return dateText.concat(" ∙ ", getClock(t, "ap sh:MM"));
    } else {
      const month = getCalendar(t, "sm") + "월 ";
      const day = getCalendar(t, "zd") + "일 ";
      const hour = getClock(t, "ww").concat(" ∙ ", getClock(t, "ap sh:MM"));
      return month + day + hour;
    }
  };

  const renderButton = () => {
    if (
      notification.alarmType === "MANAGER_ALARM_MEMBER" ||
      notification.alarmType === "MANAGER_ALARM_COACH" ||
      notification.alarmType === "MANAGER_ALARM_SMS_NOTICE"
    )
      return null;
    return (
      <NotiButton onClick={getButtonAction()}>{getButtonTitle()}</NotiButton>
    );
  };

  return (
    <MainWrapper isUnread={isRead}>
      <Icon>
        <img src={NOTIFICATION_ICON_MAP[notification.alarmType]} />
      </Icon>

      <NotiDetails>
        <p className="branch">
          {notification.partnerName} {notification.branchName}
        </p>
        <p className="title">{notification.title}</p>
        <p className="content">{notification.message}</p>
        {renderButton()}
        <p className="date">{convertNotificationDate(notification.sendDt)}</p>
      </NotiDetails>
    </MainWrapper>
  );
};

const MainWrapper = styled.div`
  width: 100%;
  min-height: 160px;
  height: auto;
  padding: 20px;
  display: flex;
  flex-direction: row;
  background-color: ${(props) => (props.isUnread ? "#FFFFFF" : "#EEF5FF")};
`;

const Icon = styled.div`
  min-width: 40px;
  min-height: 40px;
  margin-right: 12px;
`;

const NotiDetails = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  width: 100%;

  p {
    text-overflow: ellipsis;
    overflow: hidden;
  }

  p.branch {
    font-size: 12px;
    line-height: 16px;
    color: #9a9ea8;
    margin-bottom: 8px;
  }

  p.title {
    font-size: 15px;
    line-height: 20px;
    font-weight: 600;
    color: #3c3f44;
    margin-bottom: 4px;
  }

  p.content {
    font-size: 14px;
    line-height: 24px;
    color: #515458;
    margin-bottom: 8px;
  }

  p.date {
    font-size: 12px;
    line-height: 16px;
    font-feature-settings:
      "tnum" on,
      "lnum" on;
    color: #9a9ea8;
  }
`;

const NotiButton = styled.button`
  height: 40px;
  outline: none;
  border: 1px solid #e1e6ed;
  border-radius: 6px;
  background-color: white;
  margin-bottom: 8px;
  padding: 10px 0;
  text-align: center;
  font-size: 14px;
  line-height: 20px;
  color: #515458;
`;

export default NotificationItem;
